import { gpHome } from '../app';
import { IAuthService } from './auth-service';
import { AccountsService } from './accounts-service';
import { ISubscriptionStatus } from '../../app-common/services/current-user-service';
import { IAuthorisationStatus } from '../../app-common/services/authorisation-checker-with-caching-service';

gpHome.factory('gpRouteAuthService', [
    '$route',
    'authService',
    '$interval',
    '$rootScope',
    'accountsService',
    '$location',
    function ($route: ng.route.IRouteService, authService: IAuthService, $interval: ng.IIntervalService, $rootScope: ng.IRootScopeService, accountsService: AccountsService, $location: ng.ILocationService) {
        return new RouteAuthService($route, authService, $interval, $rootScope, accountsService, $location);
    }
]);

export interface IRouteAuthServiceEvents {
    loggedIn(status: IAuthorisationStatus): void;
    loggedOut(email: string | null): void;
}

export interface IRouteAuthService {
    register(events: IRouteAuthServiceEvents): void;
    deregister(events: IRouteAuthServiceEvents): void;
}

class RouteAuthService implements IRouteAuthService {
    private currentView: IRouteAuthServiceEvents | null = null;
    private lastKnownEmail: string | null = null;

    constructor(
        private $route: ng.route.IRouteService,
        private authService: IAuthService,
        $interval: ng.IIntervalService,
        $rootScope: ng.IRootScopeService,
        private accountsService: AccountsService,
        private $location: ng.ILocationService,
    ) {
        $rootScope.$on('$routeChangeSuccess', () => {
            // console.log("RouteChangeSuccess", $route.current.locals.$scope);
        });
        $rootScope.$on('$viewContentLoaded', () => {
            // console.log("viewContentLoaded", $route.current.locals.$scope);
            this.authService.resetCheckedStatus();
            this.checkIfAuthorized();
            this.refreshCapabilities();
        });


        this.authService.resetCheckedStatus();
        this.checkIfAuthorized();
        this.refreshCapabilities();
        $interval(() => {
            this.authService.resetCheckedStatus();
            this.checkIfAuthorized();
        }, 60000)
    }

    register(events: IRouteAuthServiceEvents) {
        this.currentView = events;
    }

    deregister(events: IRouteAuthServiceEvents) {
        if (this.currentView === events) {
            this.currentView = null;
        }
    }

    private notifyCurrentView(handlerFunc: (handlers: IRouteAuthServiceEvents) => void) {
        if (this.currentView) {
            handlerFunc(this.currentView);
        }
    }

    checkIfAuthorized() {
        var authChecker = this.authService.checkAuthorisationIfNeeded();
        authChecker.catch(() => {
            // we log out so that nothing else thinks we are logged in, 
            // so when we go to the login page it correctly asks for 
            // login details instead of attempting to show user data.
            this.authService.logOut();

            switch (this.$location.path()) {
                case '/plans':
                case '/templates':
                case '/account':
                    this.$location.path("/login");
            }
            this.notifyCurrentView(handlers => handlers.loggedOut(this.lastKnownEmail));
        });
        authChecker.then(status => {
            this.lastKnownEmail = status ? status.email : this.lastKnownEmail;
            this.notifyCurrentView(handlers => handlers.loggedIn(status));
        }).catch(err => { });
    }

    /**
     * The discarded response is the point: fetching subscription status refills the
     * capability snapshot, so a gate asked after a navigation has a current answer.
     *
     * It used to fan the response out to the views as a `subscriptionStatus` event,
     * back when the response carried a verdict each of them re-derived. Entitlement
     * is capabilities now, so there is nothing left to hand anybody.
     */
    refreshCapabilities() {
        this.accountsService.getSubscriptionStatus().catch(err => { });
    }
}
